import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class TamilNaduOpenUniversityDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <p><b>Tamil Nadu Open University :</b> The University established in the year 2002 and based in Chennai is meant for Open and distance learning providing a purpose to spread education to everyone. With MIET and its rich materials, you could be well equipped to succeed in overcoming the course.</p>
				  
                  </ScrollAnimation>
                  
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<h5 className="mb-0 mt-2">Courses Offered: </h5>
                            <p>UG Programmes:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – English
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Urdu
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Tamil
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – History
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Economics 
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Public Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Social Work
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Business Economics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Public Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Political Science
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Sociology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Criminology and Criminal Justice Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Functional Tamil
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – English and Communication
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – History and Heritage Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. – Tourism and Travel Studies
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Business Administration – BBA. (Computer Applications)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Business Administration – BBA.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Business Administration – BBA (Marketing Management)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Business Administration – BBA (Retail Management)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Commerce – B.Com.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Literature (B.Litt. – Tamil)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Commerce – B.Com. (Bank Management)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Commerce – B.Com. (Corporate Secretaryship)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Commerce – B.Com. (Accounting and Finance)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Commerce – B.Com.(Computer Applications)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Computer Application – BCA
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Computer Applications- BCA for Diploma Students of Polytechnic College (Simultaneous Registration – SE)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Bachelor of Computer Applications (Lateral Entry) BCA-LE
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Psychology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Computer Science
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. (Hospitality & Hotel Administration)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. (Hospitality & Hotel Administration for Diploma Students)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. (Hospitality & Hotel Administration for Ex Diploma Holders)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Geography
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Mathematics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Mathematics with Computer Applications
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							{/* <h5 className="mb-0 mt-2">Courses Offered: </h5> */}
                            <p>PG Programmes:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Master of Business Administration – M.B.A
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />MBA Shipping and Logistics Management
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />MBA Hospital Administration
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />MBA Retail Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Master of Computer Application -M.C.A
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Master of Computer Application Lateral Entry – (M.C.A- LE)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. – Psychology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. – Counselling and Psychotherapy
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. – Counselling and Psychotherapy (Lateral Entry)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. – Mathematics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Master of Commerce – M.Com
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – English
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – History
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – Public Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – Political Science
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – Tamil
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – Sociology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – Social Work
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – Economics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – Tourism and Travel Studies
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A – Criminology and Criminal Justice Administration
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							{/* <h5 className="mb-0 mt-2">Courses Offered: </h5> */}
                            <p>Diploma courses:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Accounting and Finance
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Financial Management
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Functional Arabic
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Hospital Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Human Resource Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Information Security and Cyber Law
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Intellectual Property Rights
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma  Course in Labour Law
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Logistics & Supply Chain Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Marketing Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma  Course in Naturopathy and Yogic Sciences
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Police Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in School Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Systems Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Taxation, Finance and Investment
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Teaching Methodology in Music
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Tourism and Travel Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Diploma Course in Yoga
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>	
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>				
				  </div>
		      </div>
			  <Sidebar courseRestriction="Tamil Nadu Open University"/>
		    </div>
		  </div>
		</div>

        }
}

export default TamilNaduOpenUniversityDetails